/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.Discounts {
    'use strict';

    class ServiceFilterModalController {

        static $inject = [
            'serviceFilter',
            '$mdDialog',
        ];

        constructor(
            public serviceFilter: IServiceFilter,
            protected $mdDialog: angular.material.IDialogService
        ) {
        }

        public cancel() {
            this.$mdDialog.cancel();
        }

        public clear() {
            this.serviceFilter = {
                serviceCategories: [],
            };
            this.$mdDialog.hide(this.serviceFilter);
        }

        public ok() {
            this.$mdDialog.hide(this.serviceFilter);
        }
    }

    angular.module('meevo.plugins.discounts')
        .controller('meevo.plugins.discounts.ServiceFilterModalController', ServiceFilterModalController);
}